import { convertUnit } from "./converters/convert-units";

// Extracted after WeekDay.js and MultiWeekView.js were found carrying
// byte-identical copies of this same formatter (training calendar's weekly
// volume total) - now also used by annual-planner-helpers.js's Tracked
// Results "Weekly volume" stat, per the lead's explicit ask that it look
// exactly like the rest of the app's volume display, not its own rounding.
//
// `vol` always arrives in kg (every set's load is stored in kg regardless of
// the athlete's own unit preference - same convention as getLoadAndUnit/
// getBodywweightAndUnit) - it wasn't actually converted for imperial before,
// just relabeled "lb" on the same kg number.
export const formatVolume = (vol, units) => {
  if (!vol) return null;
  const label = units === "metric" ? "kg" : "lb";
  const displayVol = units === "metric" ? vol : convertUnit(vol, "kg", "lb");
  const display =
    displayVol >= 1000
      ? `${Math.round(displayVol / 100) / 10}k`
      : `${Math.round(displayVol)}`;
  return `${display} ${label}`;
};
